import React, { useState, useEffect } from 'react';
import {
  Box,
  Container,
  Typography,
  TextField,
  Grid,
  Radio,
  Modal,
  RadioGroup,
  FormControlLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  styled,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  AppBar,
  Toolbar,
  Paper
} from '@mui/material';
import { Navigate, useNavigate } from 'react-router-dom';
import InfoIcon from "@mui/icons-material/Info";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CircularProgress from '@mui/material/CircularProgress';
import InputAdornment from "@mui/material/InputAdornment";
import LocationOnIcon from "@mui/icons-material/LocationOn";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


const AddEmployee = () => {
  const [isMaster, setIsMaster] = useState(false);
const [branches, setBranches] = useState([]);
const [selectedBranchId, setSelectedBranchId] = useState(1);
  const [isImageUploading, setIsImageUploading] = useState(false);
const [isResumeUploading, setIsResumeUploading] = useState(false);
const [isSaving, setIsSaving] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [missingFields, setMissingFields] = useState([]);
  const [showMissingFieldsModal, setShowMissingFieldsModal] = useState(false);
  const [showUserGuide, setShowUserGuide] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  let navigate = useNavigate();
  const [employeeCode, setEmployeeCode] = useState("");
  const [employeeName, setEmployeeName] = useState("");
  const [dob, setDob] = useState("");
  const [doj, setDoj] = useState("");
  const [gender, setGender] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [department, setDepartment] = useState("");
  const [designation, setDesignation] = useState("");
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [maritalStatus, setMaritalStatus] = useState("");
  const [resume, setResume] = useState(null);
  const [imagePath, setImagePath] = useState("");
  const [resumePath, setResumePath] = useState("");
  const [loadingBarProgress, setLoadingBarProgress] = useState("");
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedResume, setSelectedResume] = useState(null);
  const [nameError, setNameError] = useState(false);
  const [genderError, setGenderError] = useState(false);
  const [maritalStatusError, setMaritalStatusError] = useState(false);
  const [departmentError, setDepartmentError] = useState(false);
  const [designationError, setDesignationError] = useState(false);
  const [countryError, setCountryError] = useState(false);
  const [stateError, setStateError] = useState(false);
  const [cityError, setCityError] = useState(false);
  const [mobileError, setMobileError] = useState(false);
  const [dojError, setDojError] = useState(false);

const fetchBranches = async () => {
  try {
    const apiUrl = process.env.REACT_APP_BASE_URL;
    const token = sessionStorage.getItem("token");
    const response = await fetch(`${apiUrl}/Branch/GetBranch`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: token },
      body: JSON.stringify({}),
    });
    if (response.ok) {
      const data = await response.json();
      setBranches(data);
    } else {
      console.error("Failed to fetch branches");
    }
  } catch (error) {
    console.error("Error fetching branches:", error);
  }
};

useEffect(() => {
  const isMasterUser = sessionStorage.getItem("is_Master") === "true";
  setIsMaster(isMasterUser);

  if (isMasterUser) {
    fetchBranches();
  } else {
    const branchId = sessionStorage.getItem("branchId");
    setSelectedBranchId(branchId);
  }
}, []);

  const StyledButton = styled(Button)(({ theme }) => ({
    borderRadius: 20,
    padding: "8px 24px",
    textTransform: "none",
    fontWeight: 600,
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
    },
  }));


  useEffect(() => {
    const token = sessionStorage.getItem("token");

    const fetchData = async (url, stateSetter, payload = {}) => {
      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify(payload),
        });
        const data = await response.json();
        if (data && data !== null && data.length > 0) {
          stateSetter(data);
        } else {
          stateSetter([]);
        }
      } catch (error) {
        console.error(`Error fetching data: ${error}`);
      }
    };

    fetchData(
      "https://wsms.aidigitalsec.com/api/Registration/ddlCountry",
      setCountries
    );
    fetchData(
      "https://wsms.aidigitalsec.com/api/Department/DepartmentName",
      setDepartments
    );
    fetchData(
      "https://wsms.aidigitalsec.com/api/Designation/DesignationName",
      setDesignations
    );

    if (country !== "") {
      fetchData(
        "https://wsms.aidigitalsec.com/api/Registration/ddlState",
        setStates,
        { countryId: country }
      );
    }

    if (state !== "" && country !== "") {
      fetchData(
        "https://wsms.aidigitalsec.com/api/Registration/ddlCity",
        setCities,
        { stateId: state, countryId: country }
      );
    }
  }, [country, state]);

  const handleImageSelect = (e) => {
    setSelectedImage(e.target.files[0]);
  };

  const handleImageUpload = async () => {
    setIsImageUploading(true);
    try {
      const formData = new FormData();
      formData.append("file", selectedImage);

      const token = sessionStorage.getItem("token");
      const response = await fetch(
        "https://wsms.aidigitalsec.com/api/Employee/EmployeeImageUpload",
        {
          method: "POST",
          headers: {
            Authorization: token,
          },
          body: formData,
        }
      );

      if (response.ok) {
        const responseData = await response.json();
        setImagePath(responseData.filePath);
        // alert("Image uploaded successfully.");
        setSnackbarMessage('Image uploaded successfully.');
        setOpenSnackbar(true);
        setSnackbarSeverity("success");
      } else {
        // alert("Failed to upload image.");
        setSnackbarMessage('Failed to upload image.');
        setOpenSnackbar(true);
        setSnackbarSeverity("error");
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      // alert("An error occurred while uploading image. Please try again later.");
      setSnackbarMessage('An error occurred while uploading image. Please try again later.');
      setOpenSnackbar(true);
      setSnackbarSeverity("error");
    }finally {
    setIsImageUploading(false);
  }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  // Function to format date as DD-MM-YYYY
  // const formatDate = (date) => {
  //   const d = new Date(date);
  //   const day = String(d.getDate()).padStart(2, "0");
  //   const month = String(d.getMonth() + 1).padStart(2, "0");
  //   const year = d.getFullYear();
  //   return `${day}-${month}-${year}`;
  // };

  // Set the DOJ to the current date when the component mounts
  useEffect(() => {
    const currentDate = new Date().toISOString().split("T")[0];
    setDoj(currentDate);
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();

    // Reset error states
    setNameError(false);
    setGenderError(false);
    setMaritalStatusError(false);
    setDepartmentError(false);
    setDesignationError(false);
    setMobileError(false);
    setCountryError(false);
    setStateError(false);
    setCityError(false);
    setDojError(false);

    const missingFields = [];

    // Validation checks
    if (!employeeName) {
      setNameError(true);
      missingFields.push("Employee Name");
    }
    if (!gender) {
      setGenderError(true);
      missingFields.push("Gender");
    }
    if (!maritalStatus) {
      setMaritalStatusError(true);
      missingFields.push("Marital Status");
    }
    if (!department) {
      setDepartmentError(true);
      missingFields.push("Department");
    }
    if (!designation) {
      setDesignationError(true);
      missingFields.push("Designation");
    }
    if (!mobileNo) {
      setMobileError(true);
      missingFields.push("Mobile No.");
    }
    if (!country) {
      setCountryError(true);
      missingFields.push("Country");
    }
    if (!state) {
      setStateError(true);
      missingFields.push("State");
    }
    if (!city) {
      setCityError(true);
      missingFields.push("City");
    }
    if (!doj) {
      setDojError(true);
      missingFields.push("Date of Joining");
    }

    if (missingFields.length > 0) {
      setMissingFields(missingFields);
      setShowMissingFieldsModal(true);
      return;
    }
    // If any error exists, return without making the API call
    if (
      nameError ||
      genderError ||
      maritalStatusError ||
      departmentError ||
      designationError ||
      mobileError ||
      countryError ||
      stateError ||
      cityError ||
      dojError
    ) {
      // alert("Please fill out all mandatory fields.");
      setSnackbarMessage('Please fill out all mandatory fields.');
      setOpenSnackbar(true);
      setSnackbarSeverity("warning");
      return;
    }

    // Set default dob if not provided
    const formattedDob = dob ? formatDate(dob) : "01/01/1990";
 setIsSaving(true);
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const branchId = isMaster ? selectedBranchId : sessionStorage.getItem("branchId");
const response = await fetch(`${apiUrl}/Employee?Branch_Id=${branchId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: sessionStorage.getItem("token"),
        },
        body: JSON.stringify({
          employeeCode: "New",
          employeeName: employeeName,
          dob: formattedDob,
          dateOfJoining: formatDate(doj),
          gender: gender,
          phone: phone,
          mobile: mobileNo,
          emailId: email,
          counrtyId: country,
          stateId: state || 0,
          cityId: city || 0,
          departmentId: department,
          designationId: designation,
          maritalstatusId: parseInt(maritalStatus),
          imageUrl: imagePath,
          resumePath: resumePath,
        }),
      });

      if (response.ok) {
        const responseData = await response.json();
        setLoadingBarProgress(100);
        setShowSuccessModal(true);

        // Clear all fields upon successful save
        // setEmployeeCode("");
        // setEmployeeName("");
        // setDob("");
        // setDoj("");
        // setGender("");
        // setMobileNo("");
        // setPhone("");
        // setEmail("");
        // setDepartment("");
        // setDesignation("");
        // setCountry("");
        // setState("");
        // setCity("");
        // setMaritalStatus("");
        // setResume(null);
      } else {
        const responseData = await response.json();
        if (
          responseData.status === "Failed!" &&
          responseData.msg === "Details already exist!"
        ) {
          setLoadingBarProgress(30);
          // alert("Details already exist!");
          setSnackbarMessage('Details already exist!');
          setOpenSnackbar(true);
          setSnackbarSeverity("warning");
        } else {
          setLoadingBarProgress(0);
          // alert("Unable to add employee");
          setSnackbarMessage('Unable to add employee');
          setOpenSnackbar(true);
          setSnackbarSeverity("error");
        }
      }
    } catch (error) {
      console.error("API request error:", error);
      // alert("An error occurred. Please try again later.");
      setSnackbarMessage('An error occurred. Please try again later.');
      setOpenSnackbar(true);
      setSnackbarSeverity("error");
    }finally {
    setIsSaving(false);
  }
  };

  const emailIsValid = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleResumeSelect = (e) => {
    setSelectedResume(e.target.files[0]);
  };

  const handleResumeUpload = async () => {
    setIsResumeUploading(true);
    try {
      const formData = new FormData();
      formData.append("file", selectedResume);

      const token = sessionStorage.getItem("token");
      const response = await fetch(
        "https://wsms.aidigitalsec.com/api/Employee/EmployeeImageUpload",
        {
          method: "POST",
          headers: {
            Authorization: token,
          },
          body: formData,
        }
      );

      if (response.ok) {
        const responseData = await response.json();
        setResumePath(responseData.filePath);
        // alert("Resume uploaded successfully.");
        setSnackbarMessage('Resume uploaded successfully.');
        setOpenSnackbar(true);
        setSnackbarSeverity("success");
      } else {
        // alert("Failed to upload resume.");
        setSnackbarMessage('Failed to upload resume.');
        setOpenSnackbar(true);
        setSnackbarSeverity("error");
      }
    } catch (error) {
      console.error("Error uploading resume:", error);
      // alert("An error occurred while uploading resume. Please try again later.");
      setSnackbarMessage('An error occurred while uploading resume. Please try again later.');
      setOpenSnackbar(true);
      setSnackbarSeverity("error");
    }finally {
    setIsResumeUploading(false);
  }
  };

  const handleCancel = () => {
    setEmployeeCode("");
    setEmployeeName("");
    setDob("");
    setDoj("");
    setGender("");
    setMobileNo("");
    setPhone("");
    setEmail("");
    setDepartment("");
    setDesignation("");
    setCountry("");
    setState("");
    setCity("");
    setMaritalStatus("");
    setResume(null);
  };

  return (
    <Container mt={4}>
      <Box
        component="form"
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
        }}
      >
        <AppBar position="static" style={{ backgroundColor: "#0B1F3D" }}>
         <Toolbar sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
  <Typography
    variant="h4"
    component="div"
    style={{ fontWeight: "bold" }}
  >
    Add Employee{" "}
    <InfoIcon
      onClick={() => setShowUserGuide(true)}
      style={{ opacity: "0.6" }}
    />
  </Typography>

  {/* Branch Dropdown — Master Users Only */}
  {isMaster && (
    <Box sx={{ position: "relative" }}>
      <FormControl size="small" sx={{ width: 220 }}>
        <InputLabel
          sx={{
            color: "rgba(255,255,255,0.6)",
            fontSize: "0.75rem",
            fontWeight: 500,
            letterSpacing: "0.6px",
            textTransform: "uppercase",
            top: "-2px",
            "&.Mui-focused": { color: "#64B5F6" },
            "&.MuiFormLabel-filled": { color: "rgba(255,255,255,0.7)" },
          }}
        >
          Branch
        </InputLabel>
        <Select
          value={selectedBranchId || ""}
          onChange={(e) => setSelectedBranchId(e.target.value)}
          label="Branch"
          startAdornment={
            <InputAdornment position="start">
              <LocationOnIcon sx={{ fontSize: 16, color: "rgba(255,255,255,0.5)", ml: 0.5 }} />
            </InputAdornment>
          }
          sx={{
            color: "#ffffff",
            fontWeight: 500,
            fontSize: "0.875rem",
            letterSpacing: "0.3px",
            backgroundColor: "rgba(255,255,255,0.07)",
            backdropFilter: "blur(8px)",
            borderRadius: "8px",
            transition: "background-color 0.2s ease, box-shadow 0.2s ease",
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "rgba(255,255,255,0.15)",
              borderWidth: "1px",
              transition: "border-color 0.2s ease",
            },
            "&:hover": {
              backgroundColor: "rgba(255,255,255,0.11)",
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "rgba(255,255,255,0.35)",
              },
            },
            "&.Mui-focused": {
              backgroundColor: "rgba(255,255,255,0.1)",
              boxShadow: "0 0 0 3px rgba(100,181,246,0.18)",
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#64B5F6",
                borderWidth: "1.5px",
              },
            },
            "& .MuiSelect-icon": {
              color: "rgba(255,255,255,0.5)",
              transition: "color 0.2s ease",
            },
            "&.Mui-focused .MuiSelect-icon": {
              color: "#64B5F6",
            },
            "& .MuiSelect-select": {
              py: 1.1,
            },
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                mt: 0.5,
                borderRadius: "10px",
                border: "1px solid rgba(11,31,61,0.12)",
                boxShadow: "0 8px 32px rgba(11,31,61,0.18), 0 2px 8px rgba(0,0,0,0.08)",
                overflow: "hidden",
                "& .MuiList-root": { py: 0.5 },
              },
            },
          }}
        >
          {branches.map((branch) => (
            <MenuItem
              key={branch.branchId}
              value={branch.branchId}
              sx={{
                fontSize: "0.875rem",
                fontWeight: 500,
                color: "#0B1F3D",
                px: 2,
                py: 1.1,
                mx: 0.5,
                borderRadius: "6px",
                transition: "background-color 0.15s ease",
                "&:hover": {
                  backgroundColor: "rgba(11,31,61,0.07)",
                },
                "&.Mui-selected": {
                  backgroundColor: "rgba(25,118,210,0.1)",
                  color: "#1565C0",
                  fontWeight: 600,
                  "&:hover": {
                    backgroundColor: "rgba(25,118,210,0.15)",
                  },
                },
              }}
            >
              {branch.branchName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  )}
</Toolbar>
        </AppBar>
        <Paper
          elevation={3}
          sx={{ padding: 2, width: "100%", margin: "auto", marginTop: 1 }}
        >
          {/* Image Upload */}
     <Grid item xs={12} md={6} sx={{ mb: 3 }}>
  <Typography variant="subtitle2" sx={{ mb: 1, color: '#555' }}>
    Profile Image
  </Typography>
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
    <Button
      component="label"
      variant="outlined"
      size="small"
      startIcon={<CloudUploadIcon />}
      sx={{
        textTransform: 'none',
        borderRadius: '8px',
        borderColor: '#0B1F3D',
        color: '#0B1F3D',
        px: 2,
        '&:hover': { borderColor: '#0B1F3D', backgroundColor: 'rgba(11,31,61,0.04)' },
      }}
    >
      Choose File
      <input type="file" hidden onChange={handleImageSelect} />
    </Button>
    <Typography variant="body2" sx={{ color: '#666', maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
      {selectedImage ? selectedImage.name : 'No file chosen'}
    </Typography>
  <Button
  variant="contained"
  size="small"
  onClick={handleImageUpload}
  disabled={!selectedImage || isImageUploading}
  startIcon={isImageUploading ? <CircularProgress size={16} color="inherit" /> : null}
  sx={{ textTransform: 'none', borderRadius: '8px', backgroundColor: '#0B1F3D', boxShadow: 'none', px: 2, '&:hover': { backgroundColor: '#0a1a33', boxShadow: 'none' } }}
>
  {isImageUploading ? 'Uploading...' : 'Upload Image'}
</Button>
  </Box>
</Grid>
          <Grid container item spacing={3} sx={{ width: "100%" }}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Employee Code"
                placeholder="Enter employee code"
                value="New"
                InputProps={{ readOnly: true }} // Make the TextField non-editable
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Employee Name *"
                placeholder="Enter employee name"
                value={employeeName}
                onChange={(e) => setEmployeeName(e.target.value)}
                error={nameError}
                helperText={nameError ? "Name is required" : ""}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Date of Birth"
                type="date"
                value={dob}
                onChange={(e) => setDob(e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  inputProps: {
                    max: new Date().toISOString().split("T")[0],
                  },
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Date of Joining"
                type="date"
                value={doj}
                onChange={(e) => setDoj(e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  inputProps: {
                    max: new Date().toISOString().split("T")[0],
                  },
                }}
                error={dojError}
                helperText={dojError ? "Date of Joining is required" : ""}
              />
            </Grid>

            <Grid item xs={12}>
              <FormControl fullWidth component="fieldset">
                <InputLabel>Gender *</InputLabel>
                <RadioGroup
                  row
                  value={gender}
                  style={{ marginTop: "30px" }}
                  onChange={(e) => setGender(e.target.value)}
                >
                  <FormControlLabel
                    value="male"
                    control={<Radio />}
                    label="Male"
                    style={{ marginLeft: "10px" }}
                  />
                  <FormControlLabel
                    value="female"
                    control={<Radio />}
                    label="Female"
                  />
                </RadioGroup>
                {genderError && (
                  <Typography variant="caption" color="error">
                    Gender is required
                  </Typography>
                )}
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Mobile No. *"
                placeholder="Enter mobile number"
                value={mobileNo}
                onChange={(e) => setMobileNo(e.target.value)}
                error={mobileError}
                helperText={mobileError ? "Mobile number is required" : ""}
                inputProps={{ maxLength: 10 }}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Phone"
                placeholder="Enter phone number"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                inputProps={{ maxLength: 10 }}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Email"
                placeholder="Enter email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Grid>

            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel>Country *</InputLabel>
                <Select
                  label="Country"
                  value={country}
                  onChange={(e) => setCountry(e.target.value)}
                >
                  <MenuItem value="">
                    <em>Select Country</em>
                  </MenuItem>
                  {countries.map((country) => (
                    <MenuItem key={country.countryId} value={country.countryId}>
                      {country.countryName}
                    </MenuItem>
                  ))}
                </Select>
                {countryError && (
                  <Typography variant="caption" color="error">
                    Country is required
                  </Typography>
                )}
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel>State *</InputLabel>
                <Select
                  label="State"
                  value={state}
                  onChange={(e) => setState(e.target.value)}
                >
                  <MenuItem value="">
                    <em>Select State</em>
                  </MenuItem>
                  {states.map((state) => (
                    <MenuItem key={state.stateId} value={state.stateId}>
                      {state.stateName}
                    </MenuItem>
                  ))}
                </Select>
                {stateError && (
                  <Typography variant="caption" color="error">
                    State is required
                  </Typography>
                )}
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel>City *</InputLabel>
                <Select
                  label="City"
                  value={city}
                  onChange={(e) => setCity(e.target.value)}
                >
                  <MenuItem value="">
                    <em>Select City</em>
                  </MenuItem>
                  {cities.map((city) => (
                    <MenuItem key={city.cityId} value={city.cityId}>
                      {city.cityName}
                    </MenuItem>
                  ))}
                </Select>
                {cityError && (
                  <Typography variant="caption" color="error">
                    City is required
                  </Typography>
                )}
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel>Department*</InputLabel>
                <Select
                  label="Department"
                  value={department}
                  onChange={(e) => {
    setDepartment(e.target.value);
    setDesignation(''); // reset designation on department change
  }}
                >
                  <MenuItem value="">
                    <em>Select Department</em>
                  </MenuItem>
                  {departments.map((department) => (
                    <MenuItem key={department.deptId} value={department.deptId}>
                      {department.departmentName}
                    </MenuItem>
                  ))}
                </Select>
                {departmentError && (
                  <Typography variant="caption" color="error">
                    Department is required
                  </Typography>
                )}
              </FormControl>
            </Grid>

            <Grid item xs={12}>
           <FormControl fullWidth>
  <InputLabel>Designation *</InputLabel>
  <Select
    label="Designation"
    value={designation}
    disabled={!department}
    onChange={(e) => setDesignation(e.target.value)}
  >
    <MenuItem value="">
      <em>Select Designation</em>
    </MenuItem>
    {designations.filter((d) => String(d.departmentId) === String(department)).length === 0 ? (
      <MenuItem disabled value="">
        No designations available
      </MenuItem>
    ) : (
      designations
        .filter((d) => String(d.departmentId) === String(department))
        .map((designation) => (
          <MenuItem key={designation.desigId} value={designation.desigId}>
            {designation.designationName}
          </MenuItem>
        ))
    )}
  </Select>
  {designationError && (
    <Typography variant="caption" color="error">
      Designation is required
    </Typography>
  )}
</FormControl>
            </Grid>

            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel>Marital Status *</InputLabel>
                <Select
                  label="Marital Status"
                  value={maritalStatus}
                  onChange={(e) => setMaritalStatus(e.target.value)}
                >
                  <MenuItem value="">
                    <em>Select</em>
                  </MenuItem>
                  <MenuItem value="1">Single</MenuItem>
                  <MenuItem value="2">Married</MenuItem>
                  <MenuItem value="3">Divorced</MenuItem>
                </Select>
              </FormControl>
              {maritalStatusError && (
                <Typography variant="caption" color="error">
                  Marital status is required
                </Typography>
              )}
            </Grid>

         <Grid item xs={12} sx={{ mb: 3 }}>
  <Typography variant="subtitle2" sx={{ mb: 1, color: '#555' }}>
    Resume
  </Typography>
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
    <Button
      component="label"
      variant="outlined"
      size="small"
      startIcon={<CloudUploadIcon />}
      sx={{
        textTransform: 'none',
        borderRadius: '8px',
        borderColor: '#0B1F3D',
        color: '#0B1F3D',
        px: 2,
        '&:hover': { borderColor: '#0B1F3D', backgroundColor: 'rgba(11,31,61,0.04)' },
      }}
    >
      Choose File
      <input type="file" hidden onChange={handleResumeSelect} />
    </Button>
    <Typography variant="body2" sx={{ color: '#666', maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
      {selectedResume ? selectedResume.name : 'No file chosen'}
    </Typography>
   <Button
  variant="contained"
  size="small"
  onClick={handleResumeUpload}
  disabled={!selectedResume || isResumeUploading}
  startIcon={isResumeUploading ? <CircularProgress size={16} color="inherit" /> : null}
  sx={{ textTransform: 'none', borderRadius: '8px', backgroundColor: '#0B1F3D', boxShadow: 'none', px: 2, '&:hover': { backgroundColor: '#0a1a33', boxShadow: 'none' } }}
>
  {isResumeUploading ? 'Uploading...' : 'Upload Resume'}
</Button>
  </Box>
</Grid>

            <Grid item xs={12} sx={{ mt: 3 }}>
              <Button
  variant="contained"
  color="primary"
  onClick={handleSave}
  disabled={isSaving}
  startIcon={isSaving ? <CircularProgress size={18} color="inherit" /> : null}
  sx={{ mr: 2 }}
>
  {isSaving ? 'Saving...' : 'Save'}
</Button>
              <Button
                variant="contained"
                color="error"
                onClick={handleCancel}
                sx={{ ml: 2 }}
              >
                RESET
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Box>

      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            overflow: "hidden",
          }}
        >
          {/* Header */}
          <Box sx={{ backgroundColor: "#0B1F40", padding: "12px 16px" }}>
            <Typography
              id="success-modal-title"
              variant="h6"
              sx={{ color: "#fff" }}
            >
              Employee Added ✅
            </Typography>
          </Box>

          {/* Content */}
          <Box sx={{ padding: "20px" }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              Employee Data is Added Successfully.
            </Typography>

            {/* Buttons */}
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1); // go back after closing modal
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      <Modal
        open={showMissingFieldsModal}
        onClose={() => setShowMissingFieldsModal(false)}
        aria-labelledby="missing-fields-modal-title"
        aria-describedby="missing-fields-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            overflow: "hidden",
          }}
        >
          {/* Header */}
          <Box sx={{ backgroundColor: "#0B1F40", padding: "12px 16px" }}>
            <Typography
              id="missing-fields-modal-title"
              variant="h6"
              sx={{ color: "#fff" }}
            >
              Missing Fields
            </Typography>
          </Box>
          {/* Content */}
          <Box sx={{ padding: "20px" }}>
            <Typography id="missing-fields-modal-description" sx={{ mb: 2 }}>
              Please fill in the following required fields:
            </Typography>
            <ul>
              {missingFields.map((field, index) => (
                <li key={index}>- {field}</li>
              ))}
            </ul>
            {/* Buttons */}
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
              <Button
                onClick={() => setShowMissingFieldsModal(false)}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      <Snackbar
  open={openSnackbar}
  autoHideDuration={4000}
  onClose={() => setOpenSnackbar(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
    {snackbarMessage}
  </Alert>
</Snackbar>
    </Container>
  );
};

export default AddEmployee;
